import { render } from "./MdlSeleccionCotizacion.vue?vue&type=template&id=5788ab0c&scoped=true"
import script from "./MdlSeleccionCotizacion.vue?vue&type=script&lang=js"
export * from "./MdlSeleccionCotizacion.vue?vue&type=script&lang=js"

import "./MdlSeleccionCotizacion.vue?vue&type=style&index=0&id=5788ab0c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5788ab0c"]])

export default __exports__